import { Data } from "dataclass";

export class CreateTripDto extends Data {
  id: string = "";
  influencerId: string = "";
  tags: string[] = [];
  inclusions: string[] = [];
  exclusions: string[] = [];
  tripDescription: string;
  status: string = "";
  price: number = 0;
  bookingAmount: number = 0;
  cardImg: string = "";
  tripDetailBgImg: string = "";
  mobileTripDetailBgImg: string[] = [];
  tripCategory: string = "";
  tripCategoryImg: string = "";
  vacancy: string = "";
  vacancyBackground: string = "";
  tripName: string = "";
  tripIdAlias: string = "";
  tripTitleLine: string = "";
  tripPriceLine: string = "";
  curatorLine: string = "";
  curatorImg: string = "";
  curatorBgImg: string = "";
  gallery: string[] = [];
  tripDates: TripDatesDto[] = [];
  refundPolicyImg: string = "";
  quickDetails: QuickDetailsDto[] = [];
  itinerary: ItineraryDto[] = [];
  tripOverview: TripOverviewDto[] = [];
  tripStays: TripStaysDto[] = [];
  vibeGallery: string[] = [];
  uniqueness: UniquenessDto[] = [];
  location: string = "";
}

export class TripDatesDto {
  from: Date;
  to: Date;
  tripTitleLine: string = "";
}

export class QuickDetailsDto extends Data {
  itemTitle: string = "";
  itemDesc: string = "";
  itemImg: string = "";
}

export class ItineraryDto extends Data {
  heading: string = "";
  desc: string[] = [];
  img: string = "";
}

export class TripOverviewDto extends Data{
  svgIcon: string="";
  heading: string="";
  desc: string="";
}

export class TripStaysDto extends Data{
  stayImg: string="";
  stayName: string="";
  stayDesc: string="";
}

export class UniquenessDto extends Data{
  svgIcon: string="";
  heading: string="";
}